import get from 'lodash/get';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';
import { takeEvery, take, put, select } from 'redux-saga/effects';

import getAuthorUids from '../../chatConnection/helpers/getAuthorUids';
import { loggedUserIdSelector } from '../../context/selectors';
import { activeChannelIdSelector } from '../../chatConnection/selectors';

import { metadataSelector } from '../selectors/metadata';

import { consts as reqMetadata } from '../reqMetadata';
import { consts as metadata } from '../metadata';

function* getChannelMetadataWorker(action) {
  const channel = action.payload;

  const state = yield select();
  const loggedUserId = loggedUserIdSelector(state);
  const channelId = activeChannelIdSelector(state);
  const availableMeta = metadataSelector(state);

  const authorUids = uniq([loggedUserId, ...getAuthorUids(channel)]);
  const channelMeta = get(availableMeta, [channel.channelId], {});
  const availableUids = Object.keys(channelMeta).map(key => parseInt(key, 10));

  // request only missing meta data
  const ids = authorUids.filter(uid => !availableUids.includes(uid));

  if (!isEmpty(ids)) {
    yield put({
      type: reqMetadata.SEND,
      payload: {
        channelId,
        ids,
      },
    });

    // store response
    const { payload } = yield take(reqMetadata.SUCCEED);

    yield put({
      type: metadata.ADD_CHANNEL_METADATA,
      payload: {
        channelId: channel.channelId,
        meta: payload,
      },
    });
  }
}

export default function* getChannelMetadataSaga() {
  yield takeEvery([metadata.GET_CHANNEL_METADATA], getChannelMetadataWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/metadata.js